$(document).ready(function() {
	if(!document.querySelector('.C0022')) return false;
	var compareComponent = {
		$el: $('.C0022'),
		alert: document.getElementById('compare_alert'),
		cookieArray: null,
		maximum: null,
		url: null,
		// return markup
		compareLink : {
			productCompareURL: null,
			bundleCompareURL: null
		},
		compareBtn: null,
		markup: {
			blank: null,
			item: null
		},
		init: function(){
			this.markup.blank = compareComponent.$el.find('template.empty-item').clone().html();
			this.markup.item = compareComponent.$el.find('template.product-item').clone().html();
			compareComponent.$el.find('template.empty-item').remove();
			compareComponent.$el.find('template.product-item').remove();
			
			this.url = compareComponent.$el.attr('data-compare-url');
			this.maximum = compareComponent.$el.attr('data-type-plp').toUpperCase() == 'Y' ? 6 : 3;

			this.compareLink.productCompareURL = compareComponent.$el.find('.compare-control .button').data('product-compare');
			this.compareLink.bundleCompareURL = compareComponent.$el.find('.compare-control .button').data('bundle-compare');
			this.compareBtn = this.$el.find('.compare-control .btn-compare a.btn');


			this.slick.init();
			compareComponent.trigger.init();
			/* 20200320: LGEUS-12747 add */
			if(getCookie("compare_min") =="true"){
				$(compareComponent.$el).find('.compare-sticky-collspace .open').addClass('active').focus();
				$(compareComponent.$el).find('.compare-sticky-collspace .close').removeClass('active');
				compareComponent.$el.addClass('compare-min');
				$('body').addClass('compare-sticky-min');
				setCookie("compare_min","true", true);
			}			
			/* //20200320: LGEUS-12747 add */
			$('body').on({
				'initialized-plp': function(){
					if(document.querySelector('.js-compare')) {
						compareComponent.trigger.init();
					}
				}
			});
		},
		getBizType: function($obj) {
			var bizType = ($('.navigation') && $('.navigation').hasClass('b2b')) ? 'B2B' : 'B2C';
			// for search result page
			if($('.search-contents-area').length>0 && $obj) {
				if($obj.closest('.business-product-list').length>0 || $obj.closest('.products-box').hasClass('b2b')) {
					bizType = 'B2B';
				} else {
					bizType = 'B2C';
				}
			}
			return bizType;
		},
		switcher: function(e){
			e.preventDefault();

			var _this = e.currentTarget,
				status = $(_this).hasClass('added'),
				productId = _this.getAttribute('data-model-id'),
				url = compareComponent.url,
				param;
			$(_this).data('modelId', productId);
			param = encodeURI(xssfilter(jQuery.param($(_this).data())));
			var addTxt = $(_this).find('.add.sr-only').text();
			var removeTxt = $(_this).find('.remove.sr-only').text();
			/* 20200320: LGEUS-12747 add */
			if(getCookie("compare_min") =="true"){
				$(compareComponent.$el).find('.compare-sticky-collspace .open').click();
			}			
			/* //20200320: LGEUS-12747 add */
			if(!status) {
				// adobe
				adobeTrackEvent('add-to-compare', {
					products : [{sales_model_code : findSalesModelCode($(this)), model_name : findModelName($(this))}],
					page_event : {add_to_compare : true}
				});
				var maximum = compareComponent.maximum,
					cookie = getCookie(compareCookie.name),
					count;
				if(cookie) {
					cookie = cookie.indexOf('|') >= 0 ? cookie.split('|') : [cookie];
					count = cookie.length+1;
				}else {
					count = 1;
				}
				if(cookie && maximum < count){
					$(compareComponent.alert).find('.number').text(maximum);
					$(compareComponent.alert).find('.maximum').show().siblings().hide();
					
					/* PJTWAUS-6 : 20200310 modify */
					console.log('');
					if (_this != undefined) {
						$(compareComponent.alert).modal({target: _this});
					} else {
						$(compareComponent.alert).modal({target: 'show'});
					}
					console.log('');
					/*// PJTWAUS-6 : 20200310 modify */
				}else {
					var attributeCategory = compareComponent.$el.attr('data-current-category');
					var bizType = compareComponent.getBizType($(_this));
					if(attributeCategory && attributeCategory != '') {
						param = param +"&currentCategory="+compareComponent.$el.attr('data-current-category');
					}
					param = param + "&bizType="+bizType;
					if(!cookie || (compareCookie.name=="LG5_CompareCart" && bizType=="B2C") || (compareCookie.name=="LG5_B2B_CompareCart" && bizType=="B2B")) {

						if(bizType=="B2C") compareCookie.name="LG5_CompareCart";
						else compareCookie.name="LG5_B2B_CompareCart";
						ajax.noCacheCall(url, param, 'json', function(d){
							if(d.result == true || d.status == "success") {
								var data;
								data = d.data[0].productList[0];

								//console.log(data.modelType.toUpperCase());
								var currentPLP = compareComponent.$el.attr('data-type-plp'),
									flag = data.modelType.toUpperCase() == "A" || data.modelType.toUpperCase() == "G" || (data.modelType.toUpperCase() == "B" && data.bundlePlpDisplayFlag.toUpperCase() == "Y");
									flag = flag ? "Y" : "N";
								/*
								if(flag != currentPLP) {
									compareComponent.$el.attr('data-type-plp', flag);
									compareComponent.maximum = (flag == "Y" ? 6 : 3);
								}
								*/

								//if(d.data[0].categoryCheck) {
								if(flag == currentPLP) {
									compareComponent.slick.addItem(productId, data);
									compareCookie.add(productId);
									compareComponent.$el.find('.count').text(count);
									//LGEGMO-5525 PJTUSPDPUX-1 modify
									$(_this).addClass('added').prop("checked", true).attr('aria-label',removeTxt);

									// set currentCategory
									var attributeCategory = compareComponent.$el.attr('data-current-category');
									if(!attributeCategory || attributeCategory == '') {
										compareComponent.$el.attr('data-current-category', data.categoryId);
									}

									// change url 
									if(flag="Y") {
										compareComponent.compareBtn.attr('href', compareComponent.compareLink.productCompareURL+'?bizType='+bizType);
									} else {
										compareComponent.compareBtn.attr('href', compareComponent.compareLink.bundleCompareURL+'?bizType='+bizType);
									}
								} else {
									$(compareComponent.alert).find('.clear-category').show().siblings().hide();
									$(compareComponent.alert).modal('show');
								}
							}else {
								// server error
								$(compareComponent.alert).find('.clear-category').show().siblings().hide();
								$(compareComponent.alert).modal('show');
							}
						}, null, 'body');
					} else {
						$(compareComponent.alert).find('.clear-category').show().siblings().hide();
						$(compareComponent.alert).modal('show');
					}
				}
			}else {
				compareComponent.remove(productId);
				//LGEGMO-5525 PJTUSPDPUX-1 modify
				$(_this).removeClass('added').prop("checked", false).attr('aria-label',addTxt);
			}
			setTimeout(function () {
				if(!status) {
					$(_this).prop("checked", true);
				}else{
					$(_this).prop("checked", false);
				}
            }, 200);


		},
		remove: function(productId){
			var cookie = getCookie(compareCookie.name),
				count;
			if(cookie) {
				cookie = cookie.indexOf('|') >= 0 ? cookie.split('|') : [cookie];
				count = cookie.length-1;
			}else {
				count = 0;
			}
			compareComponent.slick.removeItem(productId);
			compareCookie.remove(productId);
			compareComponent.$el.find('.count').text(count);

			if(count == 0) {
				compareComponent.$el.removeAttr('data-current-category');
			}
		},
		// compare Sticky bottom layer
		slick: {
			$slideTarget: null,
			opt: {
				infinite: false,
				slidesToShow: 3,
				slidesToScroll: 1,
				arrows: true,
				dots: false,
				responsive: [
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1,
							arrows: false
						}
					}
				]
			},
			init: function(){
				var _this = compareComponent.slick,
					$el = compareComponent.$el;

				_this.$slideTarget = $el.find('.compare-product');

				// cookie product list setting
				var list = getCookie(compareCookie.name);
				if(list) {
					_this.getCookieProducts(list);
				}

				// slick init
				_this.$slideTarget.slick(_this.opt);

				mql.maxMd.addListener(_this.branch);
				_this.setMobileDisabled(); // change desktop and mobile item count

				// remove button
				_this.$slideTarget.on({
					click: function(e){
						var id = $(e.currentTarget).closest('.item').attr('data-model-id');
						compareComponent.remove(id);
					}
				}, '.close');

				// clear button
				$el.on({
					click: function(e){
						_this.$slideTarget.slick('unslick');
						_this.$slideTarget.html('');

						var html = [];
						for (var i = 0; i < 3; i++) {
							html += compareComponent.markup.blank;
						}
						_this.$slideTarget.html(html);
						_this.$slideTarget.slick(_this.opt);
						compareCookie.remove();
						//PJTUSPDPUX-1
						$('.js-compare').removeClass('added').prop("checked", false);
						$('.js-compare').each(function(){
							var addTxt = $(this).find('.add.sr-only').text();
							//LGEGMO-5525 modify
							$(this).attr('aria-label',addTxt);
						});
						$el.find('.count').text(0);
						compareComponent.$el.removeAttr('data-current-category');
						_this.switchLayer(false);
					}
				}, '.clear');
			},
			getCookieProducts: function(list){
				var url = compareComponent.$el.attr('data-compare-list'),
					bizType = compareComponent.getBizType(),
					param = compareComponent.$el.attr('data-name') + "=" + encodeURI(list)+"&bizType="+bizType;

				ajax.noCacheCall(url, param, 'json', function(d){
					if(d && d.data != null) {
						//for (var i = 0; i < d.data[0].productList.length; i++) {
						for (var i = (d.data[0].productList.length)-1; i>=0; i--) {
							var product = d.data[0].productList[i];
							compareComponent.slick.addItem(product.modelId, product);
						}
						if(d.data[0].productList[0]){
							var currentCategory = d.data[0].productList[0].categoryId;
							compareComponent.$el.attr('data-current-category', currentCategory);
							compareComponent.$el.find('.count').text(d.data[0].productList.length);
							compareComponent.slick.switchLayer(true);
							var info = d.data[0].productList[0],
								isPLP = info.modelType.toUpperCase() == "A" || info.modelType.toUpperCase() == "G" || (info.modelType.toUpperCase() == "B" && info.bundlePlpDisplayFlag.toUpperCase() == "Y");
							isPLP = isPLP ? "Y" : "N";
							compareComponent.$el.attr('data-type-plp', isPLP);
							// compareComponent.$el.attr('data-type-plp');

							if(isPLP="Y") {
								compareComponent.compareBtn.attr('href', compareComponent.compareLink.productCompareURL+'?bizType='+bizType);
							} else {
								compareComponent.compareBtn.attr('href', compareComponent.compareLink.bundleCompareURL+'?bizType='+bizType);
							}
						}
					}
					
				});
			},
			setMobileDisabled: function(){
				var _this = compareComponent.slick;
				var $thirdItem = _this.$slideTarget.find('.item:eq(2)');
				if($thirdItem.is('.no-item')) {
					$thirdItem.addClass('mobile-disable');
				}
				_this.branch(mql.maxMd);
			},
			branch: function(e){
				var _this = compareComponent.slick;
				if (e.matches) { // mobile
					_this.$slideTarget.slick('slickFilter',':not(.mobile-disable)');
				}else {
					_this.$slideTarget.slick('slickUnfilter');
				}
			},
			setBlank: function(){
				var _this = compareComponent.slick,
					count = _this.$slideTarget.find('.product').length,
					html = [],
					loop = 0;

				var blank = _this.$slideTarget.find('.no-item');
				if(blank[0]) {
					for (var i = 0; i < blank.length; i++) {
						var idx = _this.$slideTarget.slick("getSlick").slideCount - 1;
						_this.$slideTarget.slick('slickRemove', idx);
					}
				}
				if(count<3) {
					loop = (3 - count);
					for (var j = 0; j < loop; j++) {
						_this.$slideTarget.slick('slickAdd', compareComponent.markup.blank);
					}
				}

				_this.setMobileDisabled();
			},
			// add product item
			addItem: function(productId, data){
				var _this = compareComponent.slick,
					markup = compareComponent.markup.item;
				markup = markup.replace(/\*modelId\*/g, productId)
							.replace(/\*userFriendlyName\*/g, data.userFriendlyName)
							.replace(/\*mediumImageAddr\*/g, data.mediumImageAddr)
							.replace(/\*imageAltText\*/g, data.imageAltText)
							.replace(/\*modelUrlPath\*/g, data.modelUrlPath)
							.replace(/\*discountedRate\*/g, data.discountedRate)
							.replace(/\*rPrice\*/g, data.rPrice ? data.rPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 'null')
							.replace(/\*rPromoPrice\*/g, data.rPromoPrice ? data.rPromoPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 'null')
							.replace(/\*rPriceCent\*/g, data.rPriceCent)
							.replace(/\*rPromoPriceCent\*/g, data.rPromoPriceCent)
							/* LGEUS-12083 : 20190826 add */
							.replace(/\*rDiscountedPrice\*/g, data.rDiscountedPrice ? data.rDiscountedPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 'null')
							.replace(/\*rDiscountedPriceCent\*/g, data.rDiscountedPriceCent)
							/* //LGEUS-12083 : 20190826 add */
							.replace(/\*retailerPricingText\*/g, data.retailerPricingText)
							/* LGEUS-188 : 20200518 add */
							.replace(/\*buName1\*/g, data.buName1);

				// price setting
				var $template = $(markup);
				var $prices = $template.find('.price-area');
				// DC-680 20210526 modify
				if(data.modelStatusCode=='DISCONTINUED') {
					$prices.filter('.rPrice').html("");
					$prices.filter('.rPromoPrice').remove();
					$prices.filter('.retailer').remove();
				} else if (data.obsCondition == "Y") {
					if((data.rPromoPrice && data.rPromoPrice != null) && (data.rPrice && data.rPrice != null)) {
						$prices.filter('.rPrice').remove();
						$prices.filter('.retailer').remove();
					}else if(data.rPrice && data.rPrice != null){
						$prices.filter('.rPromoPrice').remove();
						$prices.filter('.retailer').remove();
					}else {
						$prices.filter('.rPrice').html("");
						$prices.filter('.rPromoPrice').remove();
						$prices.filter('.retailer').remove();
					}
				} else {
					if(data.retailerPricingFlag=="Y") {
						$prices.filter('.rPrice').remove();
						$prices.filter('.rPromoPrice').remove();
					} else {
						if((data.rPromoPrice && data.rPromoPrice != null) && (data.rPrice && data.rPrice != null)) {
							$prices.filter('.rPrice').remove();
							$prices.filter('.retailer').remove();
						}else if(data.rPrice && data.rPrice != null){
							$prices.filter('.rPromoPrice').remove();
							$prices.filter('.retailer').remove();
						}else {
							$prices.filter('.rPrice').html("");
							$prices.filter('.rPromoPrice').remove();
							$prices.filter('.retailer').remove();
						}
					}
				} 
				// DC-680 20210526 modify

				if($template.find('.model-name a').text() == 'null') {
					$template.find('.model-name a').empty();
				}

				markup = $template.get(0).outerHTML;

				_this.$slideTarget.slick('slickAdd', markup, 0, true);
				_this.setBlank();

				if(!compareComponent.$el.hasClass('active')) {
					_this.switchLayer(true);
				}
			},
			removeItem: function(id){
				var _this = compareComponent.slick,
					idx = $('.item[data-model-id="'+id+'"]').index(),
					$trigger = $('.js-compare[data-model-id="'+id+'"]');
				_this.$slideTarget.slick('slickRemove', idx);
				_this.setBlank();
				//LGEGMO-5525 modify
				if($trigger.length==1) {
					//PJTUSPDPUX-1
					$trigger.removeClass('added').prop("checked", false).attr('aria-label',$trigger.find('.add.sr-only').text()); // WA-Common-Compare
				} else {
					$trigger.each(function(idx) {
						//PJTUSPDPUX-1
						$trigger.eq(idx).removeClass('added').prop("checked", false).attr('aria-label',$trigger.eq(idx).find('.add.sr-only').text()); // WA-Common-Compare
					});
				}
				//LGEGMO-5525 modify
				if(_this.$slideTarget.find('.product').length == 0) {
					_this.switchLayer(false);
				}
			},
			switchLayer: function(open){
				var _this = compareComponent.slick;
				if(open) {
					compareComponent.$el.addClass('active');
					setTimeout(function(){
						_this.$slideTarget.slick('setPosition');

					/* 20190902 : LGEUS-11812 add */
					$(compareComponent.$el).find('.compare-sticky-collspace .open').on('click',function(){
						$(compareComponent.$el).find('.compare-sticky-collspace .open').removeClass('active');
						/* PJTWAUS-6 : 20200310 modify */
						console.log('');
						$(compareComponent.$el).find('.compare-sticky-collspace .close').addClass('active').focus();
						/* // PJTWAUS-6 : 20200310 modify */
						compareComponent.$el.removeClass('compare-min');
						/* PJTWAUS-1_KJB 20200121: add */
						$('body').removeClass('compare-sticky-min');
						/* 20200320: LGEUS-12747 add */
						setCookie("compare_min","false", true);
						/* //20200320: LGEUS-12747 add */
						/* // PJTWAUS-1_KJB 20200121: add */
					});
					$(compareComponent.$el).find('.compare-sticky-collspace .close').on('click',function(){
						/* PJTWAUS-6 : 20200310 modify */
						$(compareComponent.$el).find('.compare-sticky-collspace .open').addClass('active').focus();
						/* // PJTWAUS-6 : 20200310 modify */
						console.log('');
						$(compareComponent.$el).find('.compare-sticky-collspace .close').removeClass('active');
						compareComponent.$el.addClass('compare-min');
						/* PJTWAUS-1_KJB 20200121: add */
						$('body').addClass('compare-sticky-min');
						/* 20200320: LGEUS-12747 add */
						setCookie("compare_min","true", true);
						/* //20200320: LGEUS-12747 add */
						/* // PJTWAUS-1_KJB 20200121: add */
					});
					/* //20190902 : LGEUS-11812 add */
						compareComponent.$el.addClass('showing');
						/* PJTWAUS-1_KJB 20200121: add */
						$('body').addClass('compare-sticky-showing');
						/* // PJTWAUS-1_KJB 20200121: add */
					}, 50);
				}else {
					compareComponent.$el.removeClass('showing');
					/* PJTWAUS-1_KJB 20200121: add */
					$('body').removeClass('compare-sticky-showing');
					/* // PJTWAUS-1_KJB 20200121: add */
					compareComponent.$el.off('transitionend webkitTransitionEnd oTransitionEnd').on({
						'transitionend webkitTransitionEnd oTransitionEnd': function(){
							if(!compareComponent.$el.hasClass('showing')) {
								compareComponent.$el.removeClass('active');
								/* PJTWAUS-1_KJB 20200121: add */
								$('body').removeClass('compare-sticky-showing');
								$('body').removeClass('compare-sticky-min');
								/* // PJTWAUS-1_KJB 20200121: add */
							}
						}
					});
				}
			}
		},
		// add(or remove) to compare button
		trigger: {
			init: function(){
				$('body').off('click.jsCompare').on({
					'click.jsCompare': compareComponent.switcher
				}, '.js-compare');

				var cookie = getCookie(compareCookie.name);
				if(cookie) {
					cookie = cookie.indexOf('|') >= 0 ? cookie.split('|') : [cookie];
					for (var i = 0; i < cookie.length; i++) {
						var _addedItem = document.querySelector('.js-compare[data-model-id="'+cookie[i]+'"]');
						//PJTUSPDPUX-1
						$(_addedItem).addClass('added').prop("checked", true);
					}
				}
				// button title & text setting
				$('.js-compare').each(function(){
					var addTxt;
					if($(this).is('.added')) {
						addTxt = $(this).find('.remove.sr-only').text();
					}else {
						addTxt = $(this).find('.add.sr-only').text();
					}
					//LGEGMO-5525 modify
					$(this).attr('aria-label',addTxt);
				});
			}
		},
		cookie: null
	};

	compareComponent.init();
});
